'use strict';

(function ($) {
  var methods = {
    init: function (/*options*/) {
      /*var opts = $.extend({}, $.fn.tableFixedColumns.defaults, options);*/

      return this.each(function () {
        var _this = this;
        var $this = $(this);

        if ($this.hasClass('table-fixed-columns-init')) {
          return;
        }

        $this.addClass('table-fixed-columns-init');
        $this.on('resizeTable', function (/*e*/) {
          methods.resize.apply(_this, []);
          return false;
        });

        methods.resize.apply(_this, []);
      });
    },

    resize: function () {
      var _this = this;
      var $this = $(this);

      $this.find('.fixed-row').each(function () {
        var maxHeight = 0;
        $(this).find('> td, > th').height('auto').each(function () {
          if ($(this).outerHeight() > maxHeight) {
            maxHeight = $(this).outerHeight();
          }
        }).outerHeight(maxHeight);
      });

      return _this;
    },
  };

  $.fn.tableFixedColumns = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.tableFixedColumns');
    }

  };

  $.fn.tableFixedColumns.defaults = {};

})(jQuery);
